import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AstrologerHome from "./pages/astrologer/Home";
import AstrologerLogin from "./pages/astrologer/Login";
import AstrologerRegister from "./pages/astrologer/Register";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Products from "./pages/Products";
import Astrologers from "./pages/Astrologers";
import BookNow from "./pages/Booking";
import Unauthorized from "./pages/Unauthorized";
import Profile from "./pages/MyProfile";
import AstrologerProfile from "./pages/astrologer/MyProfile";
import ProtectedRoute, { PublicRoute } from "./components/ProtectedRoute";
import SingleProduct from "./pages/SingleProduct";
import { CartProvider } from "./contexts/CartContext";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import Wishlist from "./pages/Wishlist";
import { setupAxiosInterceptors } from "./components/axiosSetup";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Messages from "./pages/Messages";

function App() {
  useEffect(() => {
    // Attach axios interceptors globally ONCE
    setupAxiosInterceptors();
  }, []);
  return (
    <CartProvider>
      <ToastContainer position="top-right" autoClose={2000} />
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />

            {/* Public Auth Routes */}
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />
            <Route
              path="/register"
              element={
                <PublicRoute>
                  <Register />
                </PublicRoute>
              }
            />

            {/* Astrologer Auth Routes */}
            <Route
              path="/astrologer/register"
              element={
                <PublicRoute>
                  <AstrologerRegister />
                </PublicRoute>
              }
            />
            <Route
              path="/astrologer/login"
              element={
                <PublicRoute>
                  <AstrologerLogin />
                </PublicRoute>
              }
            />

            {/* Protected Astrologer Routes */}
            <Route
              path="/astrologer/home"
              element={
                <ProtectedRoute allowedRoles={["astrologer"]}>
                  <AstrologerHome />
                </ProtectedRoute>
              }
            />
            <Route
              path="/astrologer/profile"
              element={
                <ProtectedRoute allowedRoles={["astrologer"]}>
                  <AstrologerProfile />
                </ProtectedRoute>
              }
            />

            {/* Open Pages */}
            <Route path="/products" element={<Products />} />
            <Route path="/product/:slug" element={<SingleProduct />} />
            <Route path="/astrologers" element={<Astrologers />} />
            <Route path="/booking" element={<BookNow />} />
            <Route path="/cart" element={<CartPage />} />

            {/* Protected User Pages */}
            <Route
              path="/checkout"
              element={
                <ProtectedRoute allowedRoles={["user"]}>
                  <CheckoutPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/wishlist"
              element={
                <ProtectedRoute allowedRoles={["user"]}>
                  <Wishlist />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute allowedRoles={["user"]}>
                  <Profile />
                </ProtectedRoute>
              }
            />
          </Route>
          <Route
            path="/messages"
            element={
              <ProtectedRoute allowedRoles={["user"]}>
                <Messages />
              </ProtectedRoute>
            }
          />
          {/* Fallback */}
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
